import * as PropTypes from 'prop-types';

import {
  midnightBlue,
  seaGreen,
  fountainBlue,
  maroonFlush,
  studio,
  fireBush,
  mauve,
  frenchRose,
} from '@paradigm/design-system/src/colors';

export const COLORS = {
  NV: midnightBlue,
  GE: seaGreen,
  TL: fountainBlue,
  RD: maroonFlush,
  GR: studio,
  OG: fireBush,
  LC: mauve,
  YL: frenchRose,
};

const RoomItemAvatar = (props) => {
  const { name = '', color } = props;

  const chunks = name.split(' ');
  let initials;
  if (chunks.length === 1) {
    initials = chunks[0].slice(0, 2);
  } else if (chunks.length === 2) {
    initials = chunks.map((c) => c && c[0]).join('');
  } else {
    initials = [chunks[0], chunks[chunks.length - 1]]
      .map((c) => c && c[0])
      .join('');
  }

  return (
    <div className="room-item-avatar" style={{ background: COLORS[color] }}>
      <div className="initials">{initials.toUpperCase()}</div>
    </div>
  );
};

RoomItemAvatar.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
};

export default RoomItemAvatar;
